import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
    return (
        <footer className="site-footer">
            <div className="social-newsletter-area">
                <div className="container">
                    <div className="row">
                        <div className="col col-xs-12">
                            <div className="social-newsletter-content clearfix">
                                <div className="social-area">
                                    <ul className="clearfix">
                                        <li><a href="https://facebook.com" target="_blank" rel="noopener noreferrer"><i className="ti-facebook"></i></a></li>
                                        <li><a href="https://twitter.com" target="_blank" rel="noopener noreferrer"><i className="ti-twitter-alt"></i></a></li>
                                        <li><a href="https://linkedin.com" target="_blank" rel="noopener noreferrer"><i className="ti-linkedin"></i></a></li>
                                        <li><a href="https://pinterest.com" target="_blank" rel="noopener noreferrer"><i className="ti-pinterest"></i></a></li>
                                    </ul>
                                </div>
                                <div className="logo-area">
                                    <img src="assets/images/footer-logo.png" alt="Codecom Law Firm" />
                                </div>
                                <div className="newsletter-area">
                                    <div className="inner">
                                        <h3>Newsletter</h3>
                                        <form>
                                            <div className="input-1">
                                                <input type="email" className="form-control" placeholder="Email Address *" required />
                                            </div>
                                            <div className="submit clearfix">
                                                <button type="submit"><i className="fi flaticon-paper-plane"></i></button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="upper-footer">
                <div className="container">
                    <div className="row">
                        <div className="col col-lg-3 col-md-3 col-sm-6">
                            <div className="widget about-widget">
                                <div className="widget-title">
                                    <h3>About us</h3>
                                </div>
                                <p>Showed a lady fitted out with a fur hat and fur boa who sat upright, raising a heavy fur muff that covered the whole of her lower arm</p>
                            </div>
                        </div>
                        <div className="col col-lg-3 col-md-3 col-sm-6">
                            <div className="widget contact-widget service-link-widget">
                                <div className="widget-title">
                                    <h3>Our Address</h3>
                                </div>
                                <ul>
                                    <li>45/15 New alsala Avenew Booston town, Austria</li>
                                    <li><span>Phone:</span> 84667441</li>
                                    <li><span>Email:</span> demo@example.com</li>
                                    <li><span>Office Time:</span> 10AM- 5PM</li>
                                </ul>
                            </div>
                        </div>
                        <div className="col col-lg-3 col-md-3 col-sm-6">
                            <div className="widget link-widget">
                                <div className="widget-title">
                                    <h3>Usefull Links</h3>
                                </div>
                                <ul>
                                    <li><Link to="/about">About us</Link></li>
                                    <li><Link to="/services">Our services</Link></li>
                                    <li><Link to="/contact">Contact us</Link></li>
                                    <li><Link to="/team">Meet team</Link></li>
                                </ul>
                                <ul>
                                    <li><Link to="/privacy">Privacy Policy</Link></li>
                                    <li><Link to="/testimonials">Testimonials</Link></li>
                                    <li><Link to="/blog">News</Link></li>
                                    <li><Link to="/faq">FAQ</Link></li>
                                </ul>
                            </div>
                        </div>
                        <div className="col col-lg-3 col-md-3 col-sm-6">
                            <div className="widget link-widget line-widget-2">
                                <div className="widget-title">
                                    <h3>Practice Area</h3>
                                </div>
                                <ul>
                                    <li><Link to="/real-estate-law">Real Estate Law</Link></li>
                                    <li><Link to="/insurance-defence">Insurance Defence</Link></li>
                                    <li><Link to="/education-law">Education Law</Link></li>
                                    <li><Link to="/family-law">Family Law</Link></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="lower-footer">
                <div className="container">
                    <div className="row">
                        <div className="separator"></div>
                        <div className="col col-xs-12">
                            <p className="copyright">Copyright © 2024 Juristic. All rights reserved.</p>
                            <div className="extra-link">
                                <ul>
                                    <li><Link to="/privacy">Privacy & Policy</Link></li>
                                    <li><Link to="/terms">Terms</Link></li>
                                    <li><Link to="/about">About us</Link></li>
                                    <li><Link to="/faq">FAQ</Link></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
}

export default Footer;